import React from 'react';

const Analytics = () => {
  return <h1>Hello, I'm Analytics</h1>;
};

export default Analytics;
